import {useMemo} from 'react';


import * as dataUtils from '../../../../utils/dataUtils';
import useCountries from './useCountries';


function useCountryByAlpha2() {

    const countries = useCountries();

    return useMemo(() => dataUtils.keyBy(countries, 'alpha2'), [countries.length]);
}


export default useCountryByAlpha2;
